var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "eu-flex eu-justify_space-between emd-container__content" },
    [
      _c(
        "div",
        { staticClass: "eu-flex-item eu-basis_12 eu-basis_5_lg" },
        [
          _c(
            "CustomersDetailLink",
            {
              attrs: {
                tabName: "cards",
                title: _vm.$t("charge.detail.payment-method.card.number"),
                "merchant-id": _vm.merchantId,
                "account-id": _vm.accountId,
                "customer-id": _vm.customerId,
              },
              scopedSlots: _vm._u([
                {
                  key: "fallback",
                  fn: function () {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(_vm.firstSixDigits) +
                          " " +
                          _vm._s(_vm.lastFourDigits) +
                          " "
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.firstSixDigits) +
                  " " +
                  _vm._s(_vm.lastFourDigits) +
                  " "
              ),
            ]
          ),
          _c("PaymentCardsDetail", {
            attrs: {
              installments: _vm.installments,
              "exp-month": _vm.lastTransactionCard?.exp_month,
              "exp-year": _vm.lastTransactionCard?.exp_year,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "eu-flex-item eu-basis_12 eu-basis_5_lg" },
        [
          _c(
            "CustomersDetailLink",
            {
              attrs: {
                tabName: "info",
                title: _vm.$t("charge.detail.payment-method.card.name"),
                "merchant-id": _vm.merchantId,
                "account-id": _vm.accountId,
                "customer-id": _vm.customerId,
              },
              scopedSlots: _vm._u([
                {
                  key: "fallback",
                  fn: function () {
                    return [_vm._v(" " + _vm._s(_vm.holderName) + " ")]
                  },
                  proxy: true,
                },
              ]),
            },
            [_vm._v(" " + _vm._s(_vm.holderName) + " ")]
          ),
          _c("BillingAddres", {
            attrs: {
              "billing-address": _vm.lastTransactionCard?.billing_address,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }